import { useContext, useEffect } from "react";
import { store } from "../components/Store";
import { usePersonalAccountInstitutionsManager } from "./use-user-institutions";
import { useHistory, useLocation } from "react-router-dom";

const whitelist = [
	"/perfil",
	"/crear-perfil",
	"/visor",
	"/descargados",
	"/ayuda",
	"/external-auth",
	"/institutional-auth",
	"/login",
	"/admin/login",
	"/sin-conexion",
	"/password-recovery",
	"/asociacion",
	"/institucional",
	"/politica-de-privacidad",
	"/politica-de-soporte",
	"/terminos-y-condiciones",
	"/edtech-open-standard",
	"/collection-development-policy",
	"/accesibility-statement",
	"/ayuda",
	"/ayuda-sin-login",
	"/eventos",
	"/pautas",
	"/proyecto-piloto-rnbp",
];

/**
 * Maneja la navegación cuando no se encuentran instituciones asociadas al usuario de cuenta personal (perfil), solo permite el acceso a ciertas rutas definidas en un whitelist y deshabilita el botón de búsqueda.
 */
export const usePersonalAccountAccessGuard = () => {
	const history = useHistory();
	const location = useLocation();
	const { state, dispatch } = useContext(store);
	const mainDataLoaded = state.mainDataLoaded;
	const isPersonalAccount = state?.isPersonalAccount;
	const isAuth = state?.sesionActiva === "SI";
	const personalAccountInstitutions = usePersonalAccountInstitutionsManager();
	const personalAccountHasAvailableBooks = personalAccountInstitutions?.hasAvailableBooks;

	useEffect(() => {
		const isWhitelisted = whitelist.some((path) => location.pathname.startsWith(path));

		let interval = null;

		if (mainDataLoaded && isAuth && isPersonalAccount && !personalAccountHasAvailableBooks) {
			console.log("no books available in personal account.");
			if (!isWhitelisted) {
				history.replace("/perfil/institucion");
			}
			interval = setInterval(() => {
				dispatch({
					type: "CHANGE",
					path: "advancedSearch",
					value: null,
				});
			}, 100);
		}

		return () => clearInterval(interval);
	}, [
		mainDataLoaded,
		isPersonalAccount,
		isAuth,
		personalAccountHasAvailableBooks,
		location.pathname,
		history,
		dispatch,
	]);
};
